import { render, staticRenderFns } from "./TableFontSize.vue?vue&type=template&id=0c0fcb7a"
import script from "./TableFontSize.vue?vue&type=script&lang=js"
export * from "./TableFontSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports